import { FC } from 'react';
import { useLanguage } from '@/contexts';
import { useSearchBar } from '@/hooks/useSearchBar';

export const SearchBar: FC = () => {
  const { t } = useLanguage();
  const { handleSearchInputChange, handleSearchSubmit, searchQuery } = useSearchBar();

  return (
    <form onSubmit={handleSearchSubmit} className="w-full">
      <input
        type="text"
        id="global-search"
        placeholder={t("searchPrompts")}
        className="w-full p-1.5 sm:p-2 md:p-2.5 text-xs sm:text-sm md:text-base border border-gray-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-gray-900 dark:text-slate-100 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-electric-blue dark:focus:ring-blue-400 placeholder-gray-500 dark:placeholder-slate-400 transition-colors duration-200"
        value={searchQuery}
        onChange={handleSearchInputChange}
        onInput={handleSearchInputChange}
        aria-label={t("searchPrompts")}
      />
    </form>
  );
};
